import { ValiError } from 'valibot';

import { API } from '@/api';
import { fetcher, HTTPError, logger } from '@/services/fetcher';

import { type CurrencyFiltersUpdateApi, currenciesApiSchema } from '../../models';

const masterDataApi = fetcher.extend(() => ({ prefixUrl: `${API.MASTER_DATA_PUBLIC}` }));

export const fetchCurrencies = async (
  filters: CurrencyFiltersUpdateApi,
  { signal }: { signal?: AbortController['signal'] } = {},
) => {
  try {
    return await masterDataApi.get('currency', { searchParams: filters, signal }).json(currenciesApiSchema);
  } catch (error) {
    if (error instanceof ValiError || (error instanceof Error && error.name === 'ValiError')) {
      logger.warn('Validation error on currencies response', (error as ValiError<typeof currenciesApiSchema>).issues);
    }
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
